// Dialog content for the vertically displayed Series list of books (eg Twilight), when you click on a book series.

import React, { Component, useEffect, useMemo, useState } from 'react';
import {
  Dialog,
  IconButton,
  Paper,
  Toolbar,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  Tooltip,
  Button,
  withStyles,
  CircularProgress
} from '@material-ui/core';
import uuid from "uuid";
import { connect } from 'react-redux';
import styles from '../../styles/importSkill.js';
import { CheckCircle, Close, CloudDownload } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
// import { getSorting, stableSort } from '../../helpers';
// import IconCross from './../Icons/IconCross';
import './Content.css';
import { stableSort, getSorting } from '../../../src/helpers';
import LoadingModal from '../../Platform/components/Student/LoadingModal';
import ellipsis from '../../assets/Loading/Ellipsis.svg';
import BookShareCredentialsLogin from '../../Platform/components/Student/BookShareCredentialsLogin';
import { addStoryToStudent, removeFailedImportBookId } from '../../redux/actions';
import DetailsWizard from './DetailsWizard.js';
import ImportBooks from '../../Platform/components/Shared/ImportBooks.jsx';
import Download from '../../Platform/components/Shared/Download.jsx';

const rows = [
  // Table headers for the Series list of books
  { id: 'titleImageSrc', label: <FormattedMessage id="General.image" />},
  { id: 'name', label: <FormattedMessage id='General.title' /> },
  { id: 'author', label: <FormattedMessage id='General.author' /> },
  { id: 'isbn', label: <FormattedMessage id='General.isbn' /> },
  { id: 'source', label: <FormattedMessage id='General.source' /> }
];

const ReContent = (props) => {
  const [order, setOrder] = useState("asc");
  const [selected, setSelected] = useState({});
  const [orderBy, setOrderBy] = useState("difficulty");
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filteredDate, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchCategory, setSearchCategory] = useState("name");
  const [imported, setImported] = useState([]);
  const [loadingImportBook, setLoadingImportBook] = useState(false);
  const [importBookId, setImportBookId] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [loginRequired, setLoginRequired] = useState(false);
  const [storyDetails, setStoryDetails] = useState(null);
  const [isStoryImported, setIsStoryImported] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null);
  const [allReadyImportedBooks, setAllReadyImportedBooks] = useState(null);
  const [importKey, setImportKey] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [showLoadingMany, setShowLoadingMany] = useState(false);
  const [showCheckmarkMany, setShowCheckmarkMany] = useState(false);

  const [showDetailsWizard, setShowDetailWizard] = useState(false);

  const {
    classes,
    movie, // note: "movie" is a book series. misnomer. but not ready to change atm bc I don't know the impact. 
    user,
    seriesTitle,
    booksImport,
    storyId,
    books,
    bookShareList,
    student,
    dispatch
  } = props;

  const handleChildUnmount = () => {
    setSelectedBook(null);
    setShowLoading(false);
  };

  const handleSelectedBook = (e, currentBook) => {
    e.stopPropagation();
    setSelectedBook(currentBook);
    setImportKey(uuid.v4());
    setShowLoading(true);
  };

  const handleImportedBook = (currentBook) => {
    if (!allReadyImportedBooks) {
      setAllReadyImportedBooks([currentBook.name]);
    } else if (!allReadyImportedBooks.includes(currentBook.id)) {
      setAllReadyImportedBooks([...allReadyImportedBooks, currentBook.name]);
    }
  };

  const handleShowDetailsWizard = (data) => {
    let _isImported = imported.includes(data.id);
    setStoryDetails(data);
    setIsStoryImported(_isImported);
    setShowDetailWizard(true);
  };

  const handleChangePage = (event, page) => {
    setPage(page);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
  };

  const closeWizard = () => {
    setOpen(false);
    props.onClose();
  };

  const closeLoading = () => {
    setShowLoading(false);
  };

  const closeDetailsWizard = () => {
    setStoryDetails("");
    setIsStoryImported(false);
    setShowDetailWizard(false);
  };

  const data = useMemo(() => {
    return movie ? movie.items : [];
  }, [movie]);

  const handleSort = (_event, property) => {
    const orderBy = property;
    let order = "desc";
    if (orderBy === property && order === "desc") {
      order = "asc";
    }
    setOrder(order);
    setOrderBy(orderBy);
  };

  useEffect(() => {
    setOpen(true);
    if (books.length > 0 && movie.items && movie.items.length > 0) {
      const { items } = movie;
      items.forEach((_item) => {
        if (books.some((_book) => _book.name === _item.name)) {
          setImported([...imported, _item.id]);
        }
      });
    }
  }, []);

  useEffect(() => {
    setOpen(true);
  }, [movie]);

  useEffect(() => {
    if (bookShareList.length > 0 && books) {
      const newArr = importBookId.filter((_item) => {
        let bool = true;
        books.forEach(({ name }) => {
          if (_item === name) {
            bool = false;
          }
        });
        return bool;
      });
      setLoadingImportBook(false);
      setImportBookId(newArr);
    }
  }, [books, bookShareList, importBookId]);

  const importMany = async (list) => {
    setShowLoadingMany(true);

    if (list && student) {

        const books = list.items;
        const studentId = student.id;

        const addBooksForStudent = (book) => {
            if (book.items && Array.isArray(book.items)) {
                return Promise.all(book.items.map(subBook => addBooksForStudent(subBook)));
            } else {
                console.log("Import Book (id - name):", book.id, " - ", book.name);
                return dispatch(addStoryToStudent(studentId, book.id));
            }
        };

        await Promise.all(books.map(book => addBooksForStudent(book)));

        // hacked together visual indication of addBooks... call
        setTimeout(() => setShowCheckmarkMany(true), 1000)
        setTimeout(() => setShowLoadingMany(false), 1100) // just cleanup
    }
};

  return (
    <>
      <Dialog open={open} maxWidth="lg" onClose={closeWizard}>
        <Paper className="list">
          <Toolbar className="toolbar">
            <Typography noWrap className="header">
              {seriesTitle}: {movie.name}
              <Tooltip
                  title={<FormattedMessage id='Databanks.addAllSeries'/>}
                  enterDelay={300}
                  placement="right"
                >
                  <span>
                      <Download
                              checked={showCheckmarkMany}
                              loading={showLoadingMany}
                              onDownload={(e) => importMany(movie, e)}
                              // no bookId or failedImportBookIds here bc importMany
                      />   
                  </span>
              </Tooltip>
            </Typography>
            <IconButton onClick={closeWizard} className="close">
              <Close />
            </IconButton>
          </Toolbar>
          <Typography component="div" style={{ minHeight: 480 }}>
            <Table>
              <TableHead>
                <TableRow>
                  {rows.length &&
                    rows.map((row) => {
                      return (
                        <TableCell
                          key={row.id}
                          sortDirection={orderBy === row.id ? order : false}
                        >
                          <Tooltip
                            title={<FormattedMessage id="General.sort" />}
                            placement="bottom-start"
                            enterDelay={300}
                          >
                            <TableSortLabel
                              active={orderBy === row.id}
                              direction={order}
                              onClick={(ev) => handleSort(ev, row.id)}
                            >
                              {row.label}
                            </TableSortLabel>
                          </Tooltip>
                        </TableCell>
                      );
                    })}
                  <TableCell key="status">
                    <FormattedMessage id="Wizard.Braille.import" />
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data.length > 0 ? (
                  stableSort(data, getSorting(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((_data) => {
                      return (
                        <TableRow
                          hover
                          key={_data.id}
                          onClick={() => handleShowDetailsWizard(_data)}
                        >

                          {rows.length &&
                            rows.map((row, index) => {
                              let cellData = _data[row.id] && _data[row.id] !== " " ? _data[row.id] : "N/A";

                              return row.id === "titleImageSrc" || row.id === "titleImage" ? (
                                <TableCell key={index}>
                                  {(_data.titleImageSrc && _data.titleImageSrc !== " ") || (_data.titleImage && _data.titleImage !== " ") ? (
                                    <img 
                                      src={_data.titleImageSrc || _data.titleImage} 
                                      width={100} 
                                      height={150} 
                                      alt={_data.name} 
                                    />
                                  ) : (
                                    ""
                                  )}
                                </TableCell>
                              ) : (
                                <TableCell key={index} dangerouslySetInnerHTML={{ __html: cellData }}></TableCell>
                              );
                            })
                          }

                          <TableCell>
                            <Download
                              checked={
                                books.some(
                                  (book) => book.name === _data.name
                                ) ||
                                (booksImport &&
                                  booksImport.bookList &&
                                  booksImport.bookList.includes(_data.name))
                              }
                              loading={
                                showLoading && _data && selectedBook === _data
                              }
                              onDownload={(e) => {
                                // Clear the error state before attempting download
                                if (booksImport.failedImportBookIds.includes(_data.id)) {
                                  dispatch(removeFailedImportBookId(_data.id));
                                }
                                
                                handleSelectedBook(e, _data);
                              }}
                              bookId={_data.id}
                              failedImportBookIds={booksImport.failedImportBookIds}
                            />
                          </TableCell>
                        </TableRow>
                      );
                    })
                ) : (
                  <TableRow>
                    <TableCell />
                    <TableCell colSpan={5} align={"center"}>
                      <h4>No Results Found</h4>
                    </TableCell>
                    <TableCell />
                    <TableCell />
                    <TableCell />
                    <TableCell />
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 15]}
              component="div"
              count={data.length}
              labelRowsPerPage={<FormattedMessage id="Datatable.rowsPerPage" />}
              rowsPerPage={rowsPerPage}
              page={page}
              backIconButtonProps={{
                "aria-label": "Previous Page",
              }}
              nextIconButtonProps={{
                "aria-label": "Next Page",
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Typography>
        </Paper>
      </Dialog>
      {selectedBook && (
        <ImportBooks
          storyId={storyId}
          story={selectedBook}
          handleImportedBook={handleImportedBook}
          key={importKey}
          handleUnmount={handleChildUnmount}
          closeLoading={closeLoading}
        />
      )}
      {showDetailsWizard && (
        <DetailsWizard
          storyId={storyId}
          story={storyDetails}
          isImported={isStoryImported}
          open={showDetailsWizard}
          exitFunc={closeDetailsWizard}
        />
      )}
    </>
  );
};

// Legacy code; commented out. 
class Content extends Component {

//   state = {
//     order: 'asc',
//     orderBy: 'difficulty',
//     selected: {},
//     open: false,
//     page: 0,
//     rowsPerPage: 5,
//     filteredData: [],
//     searchValue: '',
//     searchCategory: 'name',
//     imported: [],
//     loadingImportBook: false,
//     importBookId: [],
//     openModal: false,
//     modalType: '',
//     loginRequired: false,
//     storyDetails: null,
//     isStoryImported: false,
//     selectedBook: null,
//     allReadyImportedBooks: [],
//     importKey: '',
//     showLoading: false

//   };

//   componentDidMount() {
//     this.setState({ open: true });
//     const {books, movie} = this.props;
//     if (books.length > 0 && movie.items && movie.items.length > 0) {
//       const { items } = movie;
//       items.forEach(item => {
//         if (books.some(book => book.name === item.name)) {
//           this.setState({ imported: [...this.state.imported, item.id]})
//         }
//       })
//     }
//   };

//   UNSAFE_componentWillReceiveProps(nextProps) {
//     if (nextProps.movie !== this.props.movie && nextProps.movie) {
//       this.setState({ open: true });
//     }

//     if (nextProps.books !== this.props.books && this.props.bookShareList.length > 0) {
//       console.log('bookId, books, booklist ', this.state.importBookId, nextProps.books, nextProps.bookList);
//       let newArr = this.state.importBookId.filter(item => {
//         let bool = true;
//         nextProps.books.forEach(({ name }) => {
//           if (item === name) {
//             bool = false;
//           }
//         });
//         return bool;
//       });
//       console.log('newArr ', newArr);
//       this.setState({ loadingImportBook: false, importBookId: newArr });
//     }

//     if (nextProps.user.hasBookShareCredentials && this.state.loginRequired) {
//       this.setState({ loginRequired: false });
//     }

//     if (nextProps.bookShareList !== this.props.bookShareList && !nextProps.bookShareList.length) {
//       this.setState({ noResultFound: true });
//     }
//   }

//   handleChildUnmount = () => {
//     this.setState({ 
//       selectedBook: null,
//       showLoading: false
//     });
//   }
//   // importSkill = (book, e) => {
//   //   e.stopPropagation();
//   //   if ((this.props.user.hasBookShareCredentials && book.source === "Bookshare") || book.source === "ObjectiveEd") {
//   //     this.props.dispatch(addStoryToStudent(this.props.storyId, book.id));
//   //     if (!this.state.imported.includes(book.id)) {
//   //       this.setState({ importBookId: [...this.state.importBookId, book.name] });
//   //       this.setState(state => ({ imported: [...state.imported, book.id] }));
//   //     }
//   //     console.log('addImport ', book);
//   //   } else {
//   //     this.setState({ loginRequired: true });
//   //   }
//   // };
//   handleSelectedBook = (e,currentBook) => {
//     e.stopPropagation();
//     this.setState({
//       selectedBook: currentBook,
//       importKey: uuid.v4(),
//       showLoading: true
//     });
    
//   }
//   handleImportedBook = (currentBook) => {
//     if (!this.state.allReadyImportedBooks.includes(currentBook.id)) {
//       this.setState({
//         allReadyImportedBooks: [...this.state.allReadyImportedBooks, currentBook.name]
//       })
//     }

//   }
//   showDetailsWizard = (data) => {
//     let isImported = this.state.imported.includes(data.id);
//     this.setState({ storyDetails: data, isStoryImported: isImported, showDetailsWizard: true });
//   };

//   handleChangePage = (event, page) => {
//     this.setState({ page });
//   };

//   handleChangeRowsPerPage = (event) => {
//     this.setState({ rowsPerPage: event.target.value });
//   };

//   closeWizard = () => {
//     this.setState({ open: false });
//     this.props.onClose();
//   }

//   closeDetailsWizard = () => {
//     this.setState({ storyDetails: '', isStoryImported: false, showDetailsWizard: false });
//   }
//   closeLoading = () => {
//     this.setState({ showLoading: false });
// }

//   render() {
//     const { classes, movie, user, seriesTitle, booksImport, storyId, books } = this.props;
//     const { orderBy, order, open, page, rowsPerPage } = this.state;
//     const data = movie && movie.items || [];
//     console.log('data, user', data, user);
//     return (
//       <>
//         <Dialog open={open} maxWidth='lg' onClose={this.closeWizard}>
//           <Paper className='list'>
//             <Toolbar className='toolbar'>
//               <Typography noWrap className='header'>
//                 {seriesTitle}: {movie.name}
//               </Typography>
//               <IconButton onClick={this.closeWizard} className='close'>
//                 <Close />
//               </IconButton>
//             </Toolbar>
//             <Typography component='div' style={{ minHeight: 480 }}>
//               <Table>
//                 <TableHead>
//                   <TableRow>
//                     {rows.length &&
//                       rows.map(row => {
//                         return (
//                           <TableCell
//                             key={row.id}
//                             sortDirection={orderBy === row.id ? order : false}
//                             colSpan={row.id === 'name' ? 2 : null}
//                           >
//                             <Tooltip
//                               title={<FormattedMessage id='General.sort' />}
//                               placement='bottom-start'
//                               enterDelay={300}
//                             >
//                               <TableSortLabel
//                                 active={orderBy === row.id}
//                                 direction={order}
//                                 onClick={(ev) => this.handleSort(ev, row.id)}
//                               >
//                                 {row.label}
//                               </TableSortLabel>
//                             </Tooltip>
//                           </TableCell>
//                         )
//                       })
//                     }
//                     <TableCell key='status'>
//                       <FormattedMessage id='Wizard.Braille.import' />
//                     </TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {data.length > 0 ?
//                     stableSort(data, getSorting(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
//                       .map(_data => {
//                         return (
//                           <TableRow
//                             hover
//                             key={_data.id}
//                             onClick={() => this.showDetailsWizard(_data)}
//                           >
//                             <TableCell>
//                               {
//                                 _data.titleImageSrc && _data.titleImageSrc !== ' '
//                                   ? <img src={_data.titleImageSrc} width={100} height={150} alt={_data.name} />
//                                   : 'N/A'
//                               }
//                             </TableCell>
//                             {rows.length &&
//                               rows.map((row, index) => {
//                                 return (
//                                   <>

//                                     <TableCell
//                                       key={index}
//                                     >
//                                       {
//                                         _data[row.id] && _data[row.id] !== ' '
//                                           ? _data[row.id]
//                                           : 'N/A'
//                                       }
//                                     </TableCell>
//                                   </>
//                                 )
//                               })
//                             }
//                             <TableCell>
                              
//                               <IconButton>
//                                 {
//                                   books.some(book => book.name === _data.name) || (booksImport && booksImport.bookList && booksImport.bookList.includes(_data.name))
//                                     ? <CheckCircle />
//                                     :
//                                     this.state.showLoading && (_data && this.state.selectedBook == _data) ?
//                                       <CircularProgress size={30} /> : <CloudDownload
//                                         onClick={(e) => this.handleSelectedBook(e, _data)}
//                                       />
//                                 }
//                               </IconButton>
//                             </TableCell>
//                           </TableRow>
//                         );
//                       })
//                     :
//                     <TableRow>
//                       <TableCell />
//                       <TableCell colSpan={5} align={"center"}>
//                         <h4>No Results Found</h4>
//                       </TableCell>
//                       <TableCell />
//                       <TableCell />
//                       <TableCell />
//                       <TableCell />
//                     </TableRow>
//                   }
//                 </TableBody>
//               </Table>
//               <TablePagination
//                 rowsPerPageOptions={[5, 10, 15]}
//                 component='div'
//                 count={data.length}
//                 labelRowsPerPage={<FormattedMessage id='Datatable.rowsPerPage' />}
//                 rowsPerPage={this.state.rowsPerPage}
//                 page={page}
//                 backIconButtonProps={{
//                   'aria-label': 'Previous Page',
//                 }}
//                 nextIconButtonProps={{
//                   'aria-label': 'Next Page',
//                 }}
//                 onPageChange={this.handleChangePage}
//                 onRowsPerPageChange={this.handleChangeRowsPerPage}
//               />
//             </Typography>
//           </Paper>
//         </Dialog>
//         {
//           this.state.selectedBook && <ImportBooks storyId={storyId} story={this.state.selectedBook}
//             handleImportedBook={this.handleImportedBook}
//             key={this.state.importKey}
//             handleUnmount={this.handleChildUnmount}
//             closeLoading={this.closeLoading} />
//         }
//         {
//           this.state.showDetailsWizard &&
//           <DetailsWizard
//             storyId={this.props.storyId}
//             story={this.state.storyDetails}
//             isImported={this.state.isStoryImported}
//             open={this.state.showDetailsWizard}
//             exitFunc={this.closeDetailsWizard}
//           />
//         }
//       </>
//     );
//   }
}

const mapState = ({ platform: { books, bookList, bookShareList, downloadBook, booksImport, student }, shared: { user } }) => {
  return {
    books,
    bookList,
    bookShareList,
    user,
    downloadBook,
    booksImport,
    student
  }
};

export default connect(mapState)(withStyles(styles)(ReContent));
